export default __webpack_public_path__ + "static/media/python.f0c9d647.png";